/* eslint-disable security/detect-non-literal-fs-filename */
import {
  ISelectItem,
  ModalContainerService,
  NotificationComponent,
} from "@aecom/core";
import { Component, HostListener, OnInit, inject } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import _ from "lodash";
import { Observable } from "rxjs";
import {
  IPRFIItem,
  IUser,
} from "src/app/api-generated";
import { ComponentCanDeactivate } from "src/app/guards/pending-changes.guard";
import IRFIViewPrepare from "src/app/models/IRFIViewPrepaer";
import LoadingService from "src/app/services/loading.service";
import LocalContractService from "src/app/services/local-contract.service";
import LocalContractUserService from "src/app/services/local-contractUser.service";
import LocalUserService from "src/app/services/local-user.service";
import BaseFunctionService from "@services/baseFunction.service";
import RFIInReviewStep from "@models/rfiInReviewStep";
import RFIStatus from "@models/rfiStatus";
import { BBJSelectUserService } from "@bbj/components";
import RFISelectUser from "@models/rfiSelectUser";
import RFIRole from "@models/rfiRoles";

@Component({
  selector: "app-inreview-qaqc-rfi",
  templateUrl: "./inreview-qaqc-rfi.component.html",
  styleUrls: ["./inreview-qaqc-rfi.component.scss"],
  standalone: false
})
export default class InreviewQaqcRfiComponent
  implements OnInit, ComponentCanDeactivate
{
  router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  loadingService = inject(LoadingService);
  activeModal = inject(ModalContainerService);
  localContractService = inject(LocalContractService);
  private localContractUserService = inject(LocalContractUserService);
  private localUserService = inject(LocalUserService);
  baseFunctionService = inject(BaseFunctionService);
  bbjSelectUserService = inject(BBJSelectUserService);

  @HostListener("window:beforeunload")
  canDeactivate(): Observable<boolean> | boolean {
    return !this.hasChanges();
  }

  enableSubmit = false;

  oldRFI: RFIInReviewStep;

  rfi: RFIInReviewStep;

  entity: IPRFIItem;

  users: IUser[];

  contractId: string;

  managerList: ISelectItem[] = [];

  coordinatorList: ISelectItem[] = [];

  canIssueRFI = false;

  public logtab = true;

  isQaQc = false;

  internalDueDate: Date;

  dueDate: Date;

  public maxInternalDueDate: string | undefined = undefined;

  public minDueDate: string | undefined = undefined;

  defaultTab = "details";

  ngOnInit(): void {
    this.loadingService.start();
    this.users = this.localUserService.getItems();
    const data: IRFIViewPrepare = this.activatedRoute.snapshot.data.RFIPrepare;
    this.entity = data.rfi;
    this.isQaQc = this.entity.Status === RFIStatus.Submitted;
    this.contractId = this.localContractService.currentContract.Guid;
    this.baseFunctionService.initUsers();
    this.oldRFI = new RFIInReviewStep(this.contractId, this.entity);
    if(!this.isQaQc)
    {
      this.internalDueDate = this.oldRFI.rfi_duedate.InternalDueDate
      ? new Date(
          this.oldRFI.rfi_duedate.InternalDueDate.replace("00:00:00.000Z", "12:00:00.000Z")
        )
      : new Date();
      this.dueDate = this.oldRFI.rfi_duedate.DueDate
        ? new Date(this.oldRFI.rfi_duedate.DueDate.replace("00:00:00.000Z", "12:00:00.000Z"))
        : new Date();
    }

    this.managerList = this.localContractUserService.getUsersDropDownByRoleIds(false, [RFIRole.Manager]);

    this.coordinatorList = this.localContractUserService.getUsersDropDownByRoleIds(false, [RFIRole.Coordinator]);

    this.rfi = JSON.parse(JSON.stringify(this.oldRFI));
    console.log("rfi", this.rfi);
    this.loadingService.stop();
  }

  get rfiSelectUser(): typeof RFISelectUser {
    return RFISelectUser;
  }

  hasChanges(): boolean {
    const old = JSON.stringify(this.oldRFI);
    const currentRFI = JSON.stringify(this.rfi);

    return old !== currentRFI || this.bbjSelectUserService.hasChanges();
  }

  IsValid(): boolean {
    if (this.rfi.QAQCCompliance) {
      if(this.isQaQc)
      {
        return (
          !(
            _.isEmpty(this.rfi.ManagerId) ||
            _.isEmpty(this.rfi.CoordinatorId)
          )
        );
      }
      else {
        return !_.isEmpty(this.rfi.rfi_duedate.InternalDueDate) && !_.isEmpty(this.rfi.rfi_duedate.DueDate)
      }
    }

    return !_.isEmpty(this.rfi.rfi_reject_detail?.Note) && this.IsInputValid();
  }

  IsInputValid(): boolean {
    return !this.baseFunctionService.isInputInvalid(this.rfi.rfi_reject_detail.Note)
  }
  submitRFI(): void {
    this.canIssueRFI = true;
    const validation = this.IsValid();

    if (validation) {
      const modalInstance = this.activeModal.open(NotificationComponent);

      modalInstance.instance.theme = "light";
      modalInstance.instance.title = this.rfi.QAQCCompliance
        ? "Confirm Action?"
        : "QA/QC Fail?";
      modalInstance.instance.body = this.rfi.QAQCCompliance
        ? "Once submitted, your task will be completed and you will no longer be able to make updates. The RFI will be distributed and the reviewers and observers will be notified."
        : "The RFI will be sent back to the DB User.";

      modalInstance.result.then((result) => {
        if (result === 1) {
          this.rfi.IsDraft = false;
          this.update();
        }
      });
    }
  }

  saveDraft(): void {
    if ((!this.rfi.QAQCCompliance && !this.IsInputValid()) || !this.hasChanges()) return;

    const modalInstance = this.activeModal.open(NotificationComponent);

    modalInstance.instance.theme = "light";
    modalInstance.instance.title = "Save as Draft?";
    modalInstance.instance.body = "Your RFI will save as draft.";

    modalInstance.result.then((result) => {
      if (result === 1) {
        this.rfi.IsDraft = true;
        this.update();
      }
    });
  }

  back(): void {
    if (this.hasChanges()) {
      this.baseFunctionService.backAfterConfirm();
    } else {
      this.baseFunctionService.back();
    }
  }

  update(): void {
    this.loadingService.start();
    this.rfi.rfi_reviewer = this.bbjSelectUserService.getSelectedUserIds(RFISelectUser.ReviewerTitle);
    this.rfi.rfi_watcher = this.bbjSelectUserService.getSelectedUserIds(RFISelectUser.ObserverTitle);
    this.baseFunctionService.update(this.rfi);
  }

  setQaqcCompliance(res: boolean): void {
    this.rfi.QAQCCompliance = res;
  }

  assignManger(e: ISelectItem): void {
    if (e && !Array.isArray(e)) {
      this.rfi.ManagerId = e?.id;
    }
  }

  assignCoordinator(e: ISelectItem): void {
    if (e && !Array.isArray(e)) {
      this.rfi.CoordinatorId = e?.id;
    }
  }

  setDate(e: Date): void {
    // console.log("setDate", e);
    this.internalDueDate = new Date(e);
    this.rfi.rfi_duedate.InternalDueDate = new Date(e).toISOString();
    this.minDueDate = this.internalDueDate.toLocaleDateString();
  }

  setDueDate(e: Date): void {
    // console.log("setDate", e);
    this.dueDate = new Date(e);
    this.rfi.rfi_duedate.DueDate = new Date(e).toISOString();
    this.maxInternalDueDate = this.dueDate.toLocaleDateString();
  }

  reassign(): void {
    this.baseFunctionService.reassign();
  }
}
